import * as Yup from "yup";
import React from "react";
import { FormItemProps } from "@/components/Form/types";
import store from "@/store";
import {snapshot} from "valtio";
import getAllProducts from "@/services/ProductService/getAllProducts";
import ImageWithLoader from "@/components/UiElements/ImageWithLoader";



const Items: Array<FormItemProps> = [

    {
        name: 'product_id',
        label: 'Single Product',
        placeholder: 'Select a product or search by SKU, Variant ID, or Title',
        type: 'Select',
        itemOptions: {
            portal: document.querySelector('body'),
            fetch: async () => {
                let {products, status} = snapshot(store);
                if (!products.length) {
                    await getAllProducts();
                    products = snapshot(store).products;
                }
                const list = products.filter(p=> !p.is_bundle)
                return [
                    ...list.map((product: any) => ({
                        label:
                            <span className={`flex flex-row gap-md items-start ${product.sku === status.selectedProductInProductPage ? "!opacity-[0.5] text-red-500" : "text-gray-400"}`}>

                                <span className={"flex flex-col text-title-md py-xs"}>

                                    {product.sku === status.selectedProductInProductPage ?
                                        <span className={"text-red-500"}>(Current Product) ${product.name}</span>
                                        :
                                        <span className={"text-gray-900"}>{product.name}</span>
                                    }

                                    <span className={" "}>
                                        <span className={"flex flex-row gap-md"} >
                                            <span >SKU: {product.sku}</span>

                                            <span >Variant: {product.variant_id}</span>

                                            <span >{product.is_enable_customization ? "Customizable" : "Not Customizable"}</span>
                                        </span>


                                    </span>


                                </span>
                            </span>,
                        value: product.product_id,
                        searchLabel: `title: ${product.name.toLowerCase()}  sku: ${product.sku} variant id: ${product.variant_id}`,
                        selectLabel:product.name,
                        data: product,
                        isDisabled: product.sku === status.selectedProductInProductPage
                    }))
                ]
            }
        },
        defaultValue: null,
        classNames: {container: 'col-span-9 '},
        autoFocus: true,
    },
    {
        name: 'quantity',
        label: 'Quantity',
        placeholder: '0',
        type: 'Number',
        itemOptions: {
            min: 1,
            max: 10
        },
        defaultValue: 1,
        validation: Yup.string().required('Quantity is required'),
        classNames: {container: 'col-span-3 '},
    },

]

export default Items;